// extracted by mini-css-extract-plugin
export default {"hidden":"styles_hidden__tIx50"};